export type SubjectValue =
  | ''
  | 'algemeen'
  | 'machtiging'
  | 'zakelijke-status'
  | 'intrekking'
  | 'inlogproblemen'
  | 'aanslag-betalen'
  | 'kosten-woz-bezwaar'
  | 'aanvullende-informatie'
  | 'fotos'
  | 'informatieverzoek-gemeente'
  | 'status-woz-bezwaar'
  | 'proceskostenvergoeding'

export type SubjectProps = {
  value: SubjectValue
  label: string
}

export const contactSubjectKeys: SubjectProps[] = [
  { value: '' as const, label: 'Selecteer onderwerp' },
  { value: 'aanslag-betalen', label: 'Aanslag betalen' },
  { value: 'intrekking', label: 'Bezwaar intrekken' },
  { value: 'kosten-woz-bezwaar', label: 'Kosten WOZ-bezwaar' },
  { value: 'machtiging', label: 'Machtiging' },
  { value: 'inlogproblemen', label: 'Problemen met inloggen' },
  { value: 'status-woz-bezwaar', label: 'Status WOZ-bezwaar' },
  { value: 'algemeen', label: 'Overige vragen' },
]

export const advisorSubjectKeys: SubjectProps[] = [
  { value: 'aanslag-betalen', label: 'Aanslag betalen' },
  { value: 'aanvullende-informatie', label: 'Aanvullende informatie' },
  { value: 'intrekking', label: 'Bezwaar intrekken' },
  { value: 'fotos', label: 'Foto’s aanleveren' },
  { value: 'informatieverzoek-gemeente', label: 'Informatieverzoek gemeente' },
  { value: 'machtiging', label: 'Machtiging' },
  { value: 'status-woz-bezwaar', label: 'Status WOZ-bezwaar' },
  { value: 'algemeen', label: 'Overige vragen' },
]
